import {
  IgBorderColors,
  IgCoreTextColors,
} from "@intelligems/ig-design-tokens/constants";

/** Shared by the operation bar's 28px buttons. */
const OPERATION_BUTTON_SX = {
  height: 28,
  minHeight: 28,
  py: 0,
  borderRadius: "6px",
  color: IgCoreTextColors.primary,
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "21px",
  whiteSpace: "nowrap",
} as const;

/** "Cancel" on the running bar: 72×28, borderless, 12px sides, 6px radius. */
export const OPERATION_CANCEL_SX = {
  ...OPERATION_BUTTON_SX,
  minWidth: 72,
  px: 3,
} as const;

/** "View checks" / "Hide checks" on the operation bar: a 28px outlined chip. */
export const OPERATION_TOGGLE_SX = {
  ...OPERATION_BUTTON_SX,
  // Figma's 12px side padding includes its inside 1px stroke; the CSS border
  // sits outside the padding, so 11px + 1px border matches it.
  px: "11px",
  border: `1px solid ${IgBorderColors.core.default}`,
} as const;
